import { useEffect, useRef } from 'react'
import * as Sentry from '@sentry/browser'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import useStudentPreChecks from '../../useStudentPreChecks'
import { ASR_EVENTS } from '../StudentASRConstants'
import { getCopyByGradeband } from '../../../../services/ThemingService'

const MS_TO_FAIL_STUDENT = 12000 // 12 seconds

export default function ASRAfterInitialSpeechTimer(props) {

    const {speechProps, teacherMode, openTeacherModal, history, readerManagerRef, receivedValidTranscript} = props

    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })

    const overallTimerToForceEnd = useRef()
    // Use ref to track latest receivedValidTranscript value to avoid stale closure
    const receivedTranscriptRef = useRef(receivedValidTranscript)

    // Update ref whenever receivedValidTranscript changes
    useEffect(() => {
        receivedTranscriptRef.current = receivedValidTranscript
    }, [receivedValidTranscript])

    useEffect(()=>{
        startOverAllTimer()

        return () => {
            cancelOverAllTimer()
        }

    }, [])

    const startOverAllTimer = () => {
        cancelOverAllTimer()
        overallTimerToForceEnd.current = setTimeout(forceEnd, MS_TO_FAIL_STUDENT)
    }
    const cancelOverAllTimer = () => {
        clearTimeout(overallTimerToForceEnd.current)
    }
    const forceEnd = async () => {
        if(teacherMode){
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TIMED_OUT)
            // For teacher tests, redirect back to teacher modal with timeout result
            history.push("/student/pre-checks?teacherTestResult=timeout")
        }else{
            studentPreCheck.logEvent(ASR_EVENTS.STUDENT_TIMED_OUT)
            // Force the phrase to end naturally rather than immediately opening teacher modal
            // Only call onPhraseTimeout if we've received a transcript
            // Use ref to get latest value to avoid stale closure
            if (receivedTranscriptRef.current && readerManagerRef && readerManagerRef.current && readerManagerRef.current.onPhraseTimeout) {
                readerManagerRef.current.onPhraseTimeout();
            } else {
                // Fallback to original behavior if ref is not available or no transcript received
                openTeacherModal()
            }
        }
    }

    return null
}
